export const ADD_NEW_MACHINE_REQUEST = 'ADD_NEW_MACHINE_REQUEST';
export const ADD_NEW_MACHINE_SUCCESS = 'ADD_NEW_MACHINE_SUCCESS';
export const ADD_NEW_MACHINE_FAIL = 'ADD_NEW_MACHINE_FAIL';
export const CLEAR_CLAIMING_PROCESS_STATE = 'CLEAR_CLAIMING_PROCESS_STATE';

export const unmountPage = () => {
  return {
    type: CLEAR_CLAIMING_PROCESS_STATE
  };
};
